import { render, staticRenderFns } from "./AiJdPanel.vue?vue&type=template&id=84a6c614&scoped=true&"
import script from "./AiJdPanel.vue?vue&type=script&lang=js&"
export * from "./AiJdPanel.vue?vue&type=script&lang=js&"
import style0 from "./AiJdPanel.vue?vue&type=style&index=0&id=84a6c614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a6c614",
  null
  
)

export default component.exports